import React from 'react';
import PropTypes from 'prop-types';
import {
    PRIORITY_SHIPPING_BADGE_BG,
    PRIORITY_SHIPPING_CIRCLE_BG,
    TIGERS_EYE,
    WHITE
} from '../../../utils/colors';

const ZAP_PATH =
    'M15.914 4a1.5 1.5 0 00-2.474-1.561l-9 9A1.5 1.5 0 005.5 14h4.002a.5.5 0 01.471.666L8.086 20a1.5 1.5 0 002.475 1.56l9-9A1.5 1.5 0 0018.5 10h-3.997a.5.5 0 01-.472-.667z';

/**
 * Priority shipping badge (Jumbo 60).
 * variant "rounded" = orders table (peach + tiger eye zap).
 * variant "circle" = audit / PLP Figma (yellow circle + white zap).
 */
export const IconPriorityShipping = ({
    size = 22,
    color,
    style,
    variant = 'rounded'
}) => {
    const isCircle = variant === 'circle';
    const backgroundColor = isCircle ? PRIORITY_SHIPPING_CIRCLE_BG : PRIORITY_SHIPPING_BADGE_BG;
    const fill = color ?? (isCircle ? WHITE : TIGERS_EYE);

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: size,
                height: size,
                borderRadius: isCircle ? '50%' : 6,
                backgroundColor,
                flexShrink: 0,
                ...style
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={Math.round(size * 0.64)}
                height={Math.round(size * 0.64)}
                viewBox="0 0 24 24"
                fill={fill}
                aria-hidden="true"
            >
                <path d={ZAP_PATH} />
            </svg>
        </span>
    );
};

IconPriorityShipping.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    style: PropTypes.object,
    variant: PropTypes.oneOf(['rounded', 'circle'])
};

export default IconPriorityShipping;
